import { PropsWithChildren, ReactNode, useState } from 'react'
import { observer } from 'mobx-react'
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { ExpandIcon } from './ExpandIcon'
import { useStyles } from './styled'
import { useHistory } from 'react-router'
import { AdminDrawerStore } from './models/AdminDrawerStore'
import styled from 'styled-components'
import { IAdminDrawerGroupItem, IAdminDrawerListItem } from 'common/types/admin-drawer.types'
import { CreateEventStoreState } from 'models/create-summit/create-event.store'

export interface IAdminDrawerCollapsableProps extends IAdminDrawerGroupItem {
  icon: ReactNode
  onListItemClick?: (item: IAdminDrawerListItem) => void
}

const StyledListItem = styled(ListItem)<{ active?: boolean; hasGroupItems?: boolean }>`
  && {
    background-color: ${props => (props.active ? props.theme.colors.primary : null)};
    color: ${props => (props.active ? props.theme.colors.accent1 : null)};

    :hover {
      background-color: ${props => (!props.hasGroupItems ? props.theme.colors.primary : '')};
      color: ${props => (!props.hasGroupItems ? props.theme.colors.accent1 : '')};
    }
  }
`

export const AdminDrawerCollapsable = observer(
  ({ icon, groupName, groupItems, url, onListItemClick }: PropsWithChildren<IAdminDrawerCollapsableProps>) => {
    const history = useHistory()
    const path = history.location.pathname
    const [isOpen, setIsOpen] = useState(groupItems?.some(item => {
      if (path.includes(item?.url)) return true

      // If the item's url doesn't match the structure of the current path, check if these alternate URLs do
      if (item?.altURLs) {
        return item?.altURLs?.some(altURL => {
          return path.includes(altURL)
        })
      }
    }))
    const classes = useStyles()
    const hasGroupItems = !!groupItems
    const { resetAdminEventState } = CreateEventStoreState

    return (
      <>
        <StyledListItem
          button
          active={!hasGroupItems ? path.includes(url) : false}
          hasGroupItems={hasGroupItems}
          onClick={() => {
            if (hasGroupItems) {
              setIsOpen(isOpen => !isOpen)
            } else {
              history.push(url)
            }
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={groupName} />
          {hasGroupItems && <ExpandIcon isExpanded={isOpen} />}
        </StyledListItem>
        {hasGroupItems && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {groupItems?.map(subItem => {
                return (
                  <StyledListItem
                    key={subItem?.name}
                    button
                    active={path.includes(subItem?.url) || subItem?.altURLs?.some(altURL => path.includes(altURL))}
                    className={classes.nested}
                    onClick={async () => {
                      await (onListItemClick || function () {})(subItem)
                      resetAdminEventState()
                      history.push(subItem?.url)
                    }}
                  >
                    <ListItemText primary={subItem?.name} />
                  </StyledListItem>
                )
              })}
            </List>
          </Collapse>
        )}
      </>
    )
  }
)
